import { type Price } from '@prisma/client'

/**
 * Defines our plans IDs.
 */
export const enum PlanId {
	PLOT_OWNERSHIP = 'prod_PhmVOR9htJsg8U',
	PLOT_GIFT = 'prod_Pv4n5e9JYEgmOB',
	// PLOT_GIFT = 'prod_PnDQ2VZH8tL6rr',
}

/**
 * Defines our plan pricing intervals.
 */
export const enum Interval {
	YEAR = 'year',
}

/**
 * Defines our plan pricing currencies.
 */
export const enum Currency {
	DEFAULT_CURRENCY = 'usd',
	USD = 'usd',
}

/**
 * Defines our plans structure.
 */
export const PRICING_PLANS = {
	[PlanId.PLOT_OWNERSHIP]: {
		id: PlanId.PLOT_OWNERSHIP,
		name: 'Place ownership',
		description: 'Ownership of a place',
		features: [],
		prices: {
			[Interval.YEAR]: {
				[Currency.USD]: 200,
			},
		},
	},
	[PlanId.PLOT_GIFT]: {
		id: PlanId.PLOT_GIFT,
		name: 'Place gift',
		description: 'Gift a place',
		features: [],
		prices: {
			[Interval.YEAR]: {
				[Currency.USD]: 200,
			},
		},
	},
} satisfies PricingPlan

/**
 * A helper type that defines our price by interval.
 */
export type PriceInterval<
	I extends Interval = Interval,
	C extends Currency = Currency,
> = {
	[interval in I]: {
		[currency in C]: Price['amount']
	}
}

/**
 * A helper type that defines our pricing plans structure by Interval.
 */
export type PricingPlan<T extends PlanId = PlanId> = {
	[key in T]: {
		id: string
		name: string
		description: string
		features: string[]
		prices: PriceInterval
	}
}
